import {Expressions} from '@packages/systems/wfdl';
import {
  type ExpressionElement,
  EElement,
  ERecord,
  EText,
} from '@packages/systems/wfdl-ast';
import {isOptimizationVariationElement} from '@packages/utilities/platform';
import {
  CURRENT_VARIATION_ID_PATH,
  MATCHING_VARIATION_ATOM_ID_PATH,
} from './constants';
import {TEMP_PATH} from '@packages/utilities/expression-path-constants';

export function updateCurrentVariationData({
  variationElement,
  currentVariationId,
  matchingVariationAtomId,
}: {
  variationElement: ExpressionElement;
  currentVariationId?: string | null;
  matchingVariationAtomId?: string | null;
}) {
  if (!isOptimizationVariationElement(variationElement)) {
    throw new Error('Wrong element type');
  }

  let record = ERecord({});

  if (currentVariationId) {
    record = Expressions.sparseSetIn(
      record,
      CURRENT_VARIATION_ID_PATH,
      EText(currentVariationId)
    );
  }

  if (matchingVariationAtomId) {
    record = Expressions.sparseSetIn(
      record,
      MATCHING_VARIATION_ATOM_ID_PATH,
      EText(matchingVariationAtomId)
    );
  }

  return EElement(
    Expressions.setElementData(
      variationElement,
      Expressions.sparseSetIn(
        Expressions.getElementData(variationElement),
        TEMP_PATH,
        record
      )
    )
  );
}
